var common = require("../../utiles/common.js");
var service = require("../../utiles/service");

module.exports = {
  register: function () {
    document.createElement("app-sort");
    ko.components.register("app-sort", {
      viewModel: function (params) {
        var $this = this;
        var categoryActive = decodeURIComponent(
          common.urlSearch(location.href)["categoryActive"]
        );
        var items = common.fetch("/auth/account/app/list").data;
        var getAppClassification = common.fetch(
          "/auth/account/app/getAppClassification"
        ).data;
        var appClassJson = getAppClassification.appClassJson;
        if (appClassJson) {
          appClassJson = JSON.parse(appClassJson);
        }
        console.log(appClassJson);
        var categoryList = null;
        if (categoryActive !== "所有应用") {
          categoryList = appClassJson[categoryActive];
        }
        console.log(categoryList);
        $this.items = common.getCategoryList(items, categoryList);
        $this.load = function () {
          var lis = "";
          var arr = [];
          var q = items.length;
          console.log(q);
          var h = (parseInt((q - 1) / 4) + 1) * 152;
          $(".boxList").css("height", h + "px");
          // for(var i=0;i<items.length;i++){
          //     lis+='<div class="one div9" id="'+items[i].id+'"><img class="app_img" src="/auth/image/'+items[i].icon+'.jpg"><div class="title">'+items[i].label+'</div></div>';
          // }
          //$(".boxList").html(lis);
          $(".div9").Tdrag({
            scope: ".boxList",
            pos: true,
            dragChange: true,
            changeMode: "sort",
            animation_options: {
              duration: 200, //每次动画的事件
              easing: "ease-out", //动画特效 ease-out、ease-in、linear
            },
            cbEnd: function (q) {
              $(".boxList .app_item").each(function (w, q) {
                var index = $(q).attr("index");
                arr[index] = $(q).attr("id");
              });
              var data = {
                appSort: arr,
                category:
                  categoryActive === "所有应用" ? undefined : categoryActive,
              };
              common.fetch("/auth/account/app/sortMyApp", {
                method: "POST",
                data: JSON.stringify(data),
              });
            },
          });
        };

        setTimeout(function () {
          $this.load();
        }, 1000);
      },
      template: require("./AppListSort.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/component/appSort/AppListSort.js
// module id = 185
// module chunks = 0